export const EnhanceProfileDetails: Record<string, string> = {
  SALUTATION: 'Salutation',
  SEX: 'Sex',
  DATEOFBIRTH: 'Date of Birth',
  CITYOFBIRTH: 'City of Birth',
  COUNTRYOFBIRTHCODE: 'Country of Birth',
  CITIZENSHIPCOUNTRYCODE: 'Citizenship Country',
  SOCIALID: 'SSN',
  SOCIALIDCOUNTRYCODE: 'SSN Country',
  WORK: 'Work Phone Number',
  HOME: 'Home Phone Number',
  MOBILE: 'Mobile Phone Number',
  MAILING: 'Mailing Address',
  PHYSICAL: 'Physical Address',
  SHIPPING: 'Shipping Address',
  LEGALNAME: 'Business Legal Name',
  DOINGBUSINESSASNAME: 'Business DBA Name',
  TAXID: 'Business Tax ID',
  TAXIDCOUNTRYCODE: 'Business Tax ID Country',
  DATEOFFORMATION: 'Date of Formation',
  LEGALENTITYTYPE: 'Legal Entity type',
  INDUSTRYCODE: 'Industry',
  REGISTEREDCOUNTRYCODE: 'Registered Country',
  OPERATIONCOUNTRYCODES: 'Countries of Operation',
  WEBSITE: 'Company Website',
  DRIVINGLICENSE: 'Driving License',
  PASSPORT: 'passport',
  OTHER: 'Other',
  CONTROLLER: 'Controller',
  JOBTITLE: 'Job title',
  PERCENTAGEOWNED: 'Percentage of Busines Owned',
  FORMATION: 'Formation',
  TAX: 'Tax',
  OWNERSHIP: 'Ownership',
  PRIMARYBUSINESSPHONE: 'Primary Phone of Business',
  CONTACTS: 'Contact Person',
  EMAIL: 'Email',
  BUSINESSNAME: 'Business Name on Account',
  FIRSTNAME: 'First name',
  LASTNAME: 'Last name',
  MIDDLENAME: 'Middle name',
  PHONENUMBER: 'Phone Number',
};

export const CreateIndividualEntityFields = ['First name', 'Middle name', 'Last name', 'Email', 'Phone number'];
export const CreateBusinessEntityFields = ['Business Name', 'First name', 'Last name', 'Email', 'Phone number'];

export enum LinxEntityType {
  CUSTOMER = 'CUSTOMER',
  COUNTERPARTY = 'COUNTERPARTY',
}

export enum LinxProfileType {
  New = 'NEW',
  Existing = 'EXISTING',
}

export enum LinxAccountType {
  INDIVIDUAL = 'INDIVIDUAL',
  BUSINESS = 'BUSINESS',
}

export enum LinxCounterpartyParent {
  INDIVIDUAL = 'INDIVIDUAL',
  BUSINESS = 'BUSINESS',
  MY_BUSINESS_ACCOUNT = 'MY_BUSINESS_ACCOUNT',
}

export enum LinxNotificationChannel {
  Sms = 'SMS',
  Email = 'EMAIL',
  ALL = 'ALL',
}

export enum LinxSteps {
  Notification = 'notification',
  DocumentAcceptance = 'document-acceptance',
  MoveMoney = 'move-money',
  CollectDocuments = 'collect-documents',
  SelectCountry = 'select-country',
  //Individual
  CreateIndividualAccount = 'customer-account',
  LookupIndividualProfile = 'lookup-profile',
  EnhanceIndividualProfile = 'enhance-profile',
  SubmitIndividualVerification = 'submit-kyc',
  CreateIndividualFinancialAccount = 'financial-account',
  LookupIndividualFinancialAccount = 'lookup-financial-account',
  SelectOrCreateFinancialAccount = 'select-or-create-financial-account',
  LookupOrVerifyFinancialAccount = 'lookup-or-verify-financial-account',
  LinkOrCreateFinancialAccount = 'link-or-create-financial-account',

  // Business
  CreateBusinessAccount = 'create-business-customer-account',
  LookupBusinessProfile = 'lookup-business-customer-account',
  EnhanceBusinessProfile = 'enhance-business-customer-account',
  SubmitBusinessVerification = 'submit-kyb',
  // Beneficiary
  CreateBeneficiary = 'create-beneficiary',
  LookupBeneficiary = 'lookup-beneficiary',
  EnhanceBeneficiary = 'enhance-beneficiary',
  // Counterparty
  CreateCounterparty = 'create-counterparty',
  LookupCounterparty = 'lookup-counterparty',
  EnhanceCounterparty = 'enhance-counterparty',

  LookupOrCreateDebitAuthorization = 'lookup-or-create-debit-authorization',
  CreateDebitAuthorization = 'create-debit-authorization',
}

export const LinxBusinessCustomerSteps = [
  LinxSteps.CreateBusinessAccount,
  LinxSteps.LookupBusinessProfile,
  LinxSteps.EnhanceBusinessProfile,
  LinxSteps.SubmitBusinessVerification,
  LinxSteps.LookupBeneficiary,
  LinxSteps.CreateBeneficiary,
  LinxSteps.EnhanceBeneficiary,
];

export enum LinxEnhanceAccountType {
  Individual = 'INDIVIDUAL_CUSTOMER',
  Business = 'BUSINESS_CUSTOMER',
  Benificiary = 'BENEFICIARY',
  Counterparty = 'COUNTERPARTY',
}
